module.exports = __webpack_public_path__ + "static/media/devicon.1774a796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devicon.jpg
// module id = 5744
// module chunks = 0